import NavComponent from "../lib/nav_component";

export const PaneLinkComponentConfig = {
    componentTypeKey: "PaneLinkComponent",
    baseHtmlClass: "nav_option__link",
    selector: ".nav_option__link",

    mapFilterCodeDatasetKey: "map_filter_code",

    clickedEventName: "PaneLinkComponent-clicked",
};

export class PaneLinkComponent extends NavComponent {

    static new(parentElement, paneOptionComponent) {
        let element = parentElement.querySelector(PaneLinkComponentConfig.selector);
        if (!element) return;
        return new PaneLinkComponent(element, paneOptionComponent);
    }

    constructor(id_or_element, paneOptionComponent) {
        super(id_or_element, PaneLinkComponentConfig);
        this.paneOptionComponent = paneOptionComponent;
        this.hasMapFilter = getHasMapFilter(this.element);

        this.element.addEventListener("click", this.handleClick.bind(this));
    }

    /**
     * Communicates with the native app or online app to ensure the map is configured correctly.
     *
     * Pane Link Click Event Process:
     *
     * Doesn't prevent the default action if the context is within a native app. The native app will process the URL and act accordingly to update the map.
     *
     * Dispatches a custom "clicked" event on the element which will be picked up by the OnlineApp's `OnlineAppNavOption` component which will handle URL updates (without triggering route handlers) and setting the OnlineApp's map filter etc.
     *
     * Dispatches the 'paneLinkClick' action where the pane option is selected and the Nav's map filter state is set.
     **/
    handleClick(event) {
        // The default action (URL load) is not prevented for native app context where the URL load will be handled by the native app routes and the map filter will be set.
        if (this.paneOptionComponent.shouldPreventDefaultAction()) event.preventDefault();

        // Dispatch the clicked event on the element, which will be picked up by the `OnlineAppNavOption` component which will handle URL updates and setting the OnlineApp's map filter etc.
        this.element.dispatchEvent(new CustomEvent(PaneLinkComponentConfig.clickedEventName));

        this.dispatchAction("paneLinkClick", this);
    }
}

function getMapFilterCode(element) {
    return element.dataset[PaneLinkComponentConfig.mapFilterCodeDatasetKey];
}

function getHasMapFilter(element) {
    const mapFilterCode = getMapFilterCode(element);
    return typeof mapFilterCode != "undefined" && mapFilterCode !== "";
}
